import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import DataWrapper from '../../../principal/containers/DataWrapper';
import ConsultaVeiculosStore from "../stores/ConsultaVeiculosStore";
import Footer from "../../../comum/components/Footer";
import { Container } from "reactstrap";
import FooterContent from '../../../comum/components/FooterContent';
import { Row, Col, InputGroup, Label, Button } from "reactstrap";
import { TabelaVeiculos } from '../components/TabelaVeiculos';

@inject("store")
@DataWrapper
@observer
export class ConsultaVeiculos extends Component {

    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;

        this.controller = new ConsultaVeiculosStore();
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Veículos na Triagem");
        this.appStore.showTopbar(true);
    }


    render() {
        return (
            <div>
                <div className="form-wrapper">
                    <Container fluid>
                        <TabelaVeiculos controller={this.controller} />
                    </Container>
                </div>
                <Footer>
                    <FooterContent>
                        {this.controller.total !== null &&
                            <div className="justify-content-between">
                                <div>
                                    <b>{this.controller.veiculos.length}</b> {this.controller.total === 1 ? 'registro' : 'registros'} -
                                <a onClick={() => this.controller.listarVeiculos()}>Atualizar Lista</a>
                                </div>
                            </div>
                        }
                    </FooterContent>
                </Footer>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/consultas/veiculos/telas/ConsultaVeiculos.js